import React, { RefObject } from 'react';
import { Stack } from '@mui/material';

import { SearchBar } from '../ui/Searchbar/SearchBar';

interface FacilitySearchProps {
  value: string | null;
  onChange?:
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
  autoFocus?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  inputRef?: RefObject<HTMLInputElement>;
}

export default function FacilitySearch({
  value,
  onChange,
  autoFocus,
  onKeyDown,
  inputRef
}: FacilitySearchProps) {
  return (
    <Stack
      direction="row"
      width="100%"
      px={2}
      py={1}
      alignItems="center"
      justifyContent="center"
    >
      <SearchBar
        sx={{
          width: '100%'
        }}
        searchQuery={value ?? ''}
        forceDesktopVariant
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        inputRef={inputRef}
        setSearchQuery={(value) =>
          onChange?.({
            target: { value }
          } as React.ChangeEvent<HTMLInputElement>)
        }
        placeholder="Search..."
      />
    </Stack>
  );
}
